export default {
  serviceType: [
    {
      value: 1,
      label: "现代服务*外包服务"
    },
    {
      value: 2,
      label: "现代服务*技术服务"
    },
    {
      value: 3,
      label: "现代服务*设计服务费"
    },
    {
      value: 4,
      label: "现代服务*家政服务"
    },
    {
      value: 5,
      label: "研发技术服务*技术咨询"
    },
    {
      value: 6,
      label: "物流辅助服务*你给我运输代理服务"
    },
    {
      value: 7,
      label: "企业管理服务*其他企业管理服务"
    },
    {
      value: 8,
      label: "信息技术服务*软件测试服务"
    }
  ],
  optionStArr: [
    {
      value: 2,
      label: "审核通过"
    },
    {
      value: 3,
      label: "线下支付"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  optionMsArr: [
    {
      value: 2,
      label: "线上预付"
    },
    {
      value: 3,
      label: "线下支付"
    },
    {
      value: 6,
      label: "线下预付"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  balanceOpt: [
    {
      value: 1,
      label: '支付中'
    },
    {
      value: 2,
      label: '支付成功'
    },
    {
      value: 3,
      label: '支付失败'
    },
    {
      value: 5,
      label: '退汇成功'
    },
  ],
  statusAli: [
    {
      value: 2,
      label: "审核通过"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  statusSystem: [
    {
      value: 3,
      label: "线下支付"
    },
    {
      value: 5,
      label: "驳回"
    }
  ],
  operation: [
    {
      value: 1,
      label: "线下支付"
    },
    {
      value: 2,
      label: "支付成功"
    },
    {
      value: 3,
      label: "支付失败"
    }
  ],
  refundOption: [
    {
      value: 1,
      label: "审核通过"
    },
    {
      value: 4,
      label: "驳回申请"
    },
    {
      value: 3,
      label: "线下退款"
    }
  ],
  recordOpts: [
    /* {
       value: 0,
       label: "待审核",
     },*/
    {
      value: 1,
      label: "已充值",
    },
    {
      value: 2,
      label: "已驳回",
    },
    {
      value: 3,
      label: "已退回",
    },
  ],
  recordArray: [
    {
      value: 1,
      label: "已充值",
    },
    {
      value: 2,
      label: "已驳回",
    },
  ],
  optionBank: [
    {
      value: "1",
      label: "银行卡",
    },
    {
      value: "2",
      label: "支付宝",
    },
  ],
  optionTrans: [
    {
      value: "1",
      label: "是",
    },
    {
      value: "0",
      label: "否",
    },
  ],
  customOption: [
    {
      value: "1",
      label: "未关联",
    },
    {
      value: "2",
      label: "已关联",
    },
  ],
  optionFlag: [
    {
      value: "0",
      label: "待审核",
    },
    {
      value: "1",
      label: "通过",
    },
    {
      value: "2",
      label: "驳回",
    },
  ],
  optionCheck: [
    {
      value: "1",
      label: "系统加款",
    },
    {
      value: "2",
      label: "系统扣款",
    },
    {
      value: "3",
      label: "支付宝扣款",
    },
    {
      value: "5",
      label: "支付宝记账本加款",
    },
  ],
  auditFlagOpt: [
    {
      value: "0",
      label: "待审核",
    },
    {
      value: "1",
      label: "通过",
    },
    {
      value: "2",
      label: "驳回",
    },
    {
      value: "3",
      label: "失败",
    },
  ],
  authScoOption: [
    {
      value: 1,
      label: "小程序"
    },
    {
      value: 2,
      label: "API"
    },
    {
      value: 3,
      label: "E签宝-人脸"
    },
    {
      value: 4,
      label: "E签宝-短信"
    },
    {
      value: 5,
      label: "认证不限制"
    },
    {
      value: 6,
      label: "短信"
    },
    {
      value: 7,
      label: "二维码"
    },
    {
      value: 8,
      label: "后台手动导入"
    },
    {
      value: 9,
      label: "平台同步"
    }
  ],
  // authStaOption:[
  //   {
  //     value: 0,
  //     label: "审核中"
  //   },
  //   {
  //     value: 1,
  //     label: "已认证",
  //   },
  //   {
  //     value: 2,
  //     label: "已驳回",
  //   },
  // ],
  authStaOption: [
    {
      value: 0,
      label: "审核中"
    },
    {
      value: 1,
      label: "已认证",
      name: "已签署"  // e签宝
    },
    {
      value: 2,
      label: "已驳回",
      name: "拒绝签署"
    },
    {
      value: 3,
      label: "待签署"
    },
    {
      value: 4,
      label: "已撤销"
    },
    {
      value: 5,
      label: "已过期"
    }
  ], zxnStatusOption: [
    {
      value: -1,
      label: "未认证"
    }, {
      value: 0,
      label: "审核中"
    },
    {
      value: 1,
      label: "已认证",
    }
  ],
  eSignOption: [
    {
      value: 0,
      label: "待认证"
    },
    {
      value: 1,
      label: "待签署"
    },
    {
      value: 2,
      label: "已签署",
    },
    {
      value: 3,
      label: "已撤销"
    },
    {
      value: 4,
      label: "已过期"
    }
  ],
  selfOption: [
    {
      value: "0",
      label: "待审核",
    },
    {
      value: "1",
      label: "注册中",
    },
    {
      value: "3",
      label: "注册完成",
    },
    {
      value: "2",
      label: "已驳回",
    },
  ],
  typeOptions: [
    {
      value: 1,
      label: "商户入驻"
    },
    {
      value: 2,
      label: "代理商入驻"
    },
    {
      value: 3,
      label: "资金入驻"
    },
    {
      value: 4,
      label: "快速咨询"
    },
  ],
  isContactArr: [
    {
      value: "0",
      label: "待接待",
    },
    {
      value: "1",
      label: "已接待",
    },
    {
      value: "2",
      label: "已完结",
    },
  ],
  recordOption: [
    {
      value: "0",
      label: "审核中",
    },
    {
      value: "1",
      label: "已发放",
    },
    {
      value: "2",
      label: "已驳回",
    },
  ],
  checkOption: [
    {
      value: "1",
      label: "待审核",
    },
    {
      value: "2",
      label: "已撤销",
    },
    {
      value: "3",
      label: "已注销",
    },
  ],
  callbackOption: [
    {
      value: "certification",
      label: "个人认证通知地址"
    },
    {
      value: "recharge",
      label: "充值通知地址"
    },
    {
      value: "invoice",
      label: "发票通知地址"
    },
    {
      value: "acceptance_documents",
      label: "验收文件通知地址"
    },
    {
      value: "sign_apply",
      label: "单笔支付通知地址"
    },
    {
      value: "e_sign",
      label: "API签约/E签宝签署回调"
    },
    {
      value: "merchant_info",
      label: "商户信息回调"
    },
  ],
  notTaxOption: [
    {
      value: "1",
      label: "有个税"
    },
    {
      value: "2",
      label: "无个税"
    },
  ],
  startOption: [
    {
      value: "0",
      label: "未申报"
    },
    {
      value: "1",
      label: "已申报"
    },
  ],
  amountOption: [
    {
      value: "recharge",
      label: "充值总额"
    },
    {
      value: "grant",
      label: "发放总额"
    },
    {
      value: "service",
      label: "服务费总额"
    },
  ],
  localOption: [
    {
      value: "2",
      label: "支付成功"
    },
    {
      value: "3",
      label: "支付失败"
    },
  ],
  partnerOption: [
    {
      value: 0,
      label: "支付成功"
    },
    {
      value: 1,
      label: "支付失败"
    },
  ],
  resultOption: [
    {
      value: "1",
      label: "一致"
    },
    {
      value: "0",
      label: "不一致"
    },
  ],
  checkedOption: [
    {
      value: "1",
      label: "一致"
    },
    {
      value: "2",
      label: "不一致"
    },
    {
      value: "0",
      label: "未操作"
    },
  ],
  statusOption: [
    {
      value: "0",
      label: "生成中"
    },
    {
      value: "1",
      label: "已生成"
    },
    {
      value: "2",
      label: "生成失败"
    },
  ],
  permanentOption: [
    {
      value: 1,
      label: "存在"
    },
    {
      value: 0,
      label: "不存在"
    },
  ],
  stateOption: [
    {
      value: "1",
      label: "成功"
    },
    {
      value: "0",
      label: "失败"
    },
  ],
  inOrExpOption: [
    {
      value: "1",
      label: "收入"
    },
    {
      value: "0",
      label: "支出"
    },
  ],
  validOption: [
    {
      value: true,
      label: "正常"
    },
    {
      value: false,
      label: "禁用"
    },
  ],
  requestOption: [
    {
      value: "1",
      label: "支付"
    },
    {
      value: "2",
      label: "退款"
    },
    {
      value: "3",
      label: "开票"
    },
    {
      value: "4",
      label: "提现"
    },
    {
      value: "5",
      label: "认证"
    },
    {
      value: "6",
      label: "审核"
    },
    {
      value: "7",
      label: "驳回"
    },
    {
      value: "8",
      label: "注册"
    },
    {
      value: "9",
      label: "开户"
    },
    {
      value: "10",
      label: "入驻"
    },
  ],
  statuValOption: [
    {
      value: "0",
      label: "待审核"
    },
    {
      value: "1",
      label: "已通过"
    },
    {
      value: "2",
      label: "已驳回"
    },
  ],
  msPayOpt: [
    {
      value: "1",
      label: "支付中",
    },
    {
      value: "2",
      label: "支付成功",
    },
    {
      value: "3",
      label: "支付失败",
    }
  ],
  msPayOption: [
    {
      value: "0",
      label: "转账中",
    },
    {
      value: "1",
      label: "转出成功",
    },
    {
      value: "2",
      label: "转出失败",
    },
    {
      value: "5",
      label: "收款成功",
    }
  ],
  transOption: [
    {
      value: "NONE",
      label: "无需转账",
    },
    {
      value: "NO_TRANSFER",
      label: "未转账",
    },
    {
      value: "PAYING",
      label: "已提交",
    },
    {
      value: "SUCCESS",
      label: "转账成功",
    },
    {
      value: "FAIL",
      label: "转账失败",
    }
  ],
  payOption: [
    {
      value: "NO_TRANSFER",
      label: "未转账",
    },
    {
      value: "PAYING",
      label: "转账中",
    },
    {
      value: "SUCCESS",
      label: "转账成功",
    },
    {
      value: "FAIL",
      label: "转账失败",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/options.js